export default "__VITE_ASSET__KAREirE8__"